import React, { useState } from 'react';
import { IoSend } from 'react-icons/io5'; // Import the IoSend icon
import { useChat } from '../../contexts/ChatContext';
import { useEffect } from 'react';

const InputBox = ({ chatBoxRef }) => {
  const [input, setInput] = useState('');
  const { state, sendMessage } = useChat();
  const { isLoading } = state;

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (input.trim() !== '') {
      console.log(`Sending message: ${input}`); 
      sendMessage(input);
      setInput('');
    }
  };

  useEffect(() => {
    // Scroll to chatbox only when isLoading becomes false
    if (isLoading && chatBoxRef?.current) {
      console.log('Scrolling to chatbox after isLoading');
      chatBoxRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
    
  }, [isLoading,chatBoxRef]);

  return (
    <div className="bottom-0 left-0 w-full bg-gray-800 p-4 z-50">
      <form className="flex items-center space-x-4" onSubmit={handleSendMessage}>
        <input
          type="text"
          className={`flex-1 p-3 rounded-lg border ${
            isLoading ? 'border-gray-500 bg-gray-600 text-gray-400' : 'border-gray-600 bg-gray-700 text-white'
          } focus:outline-none focus:ring-2 focus:ring-primaryColor focus:border-primaryColor`}
          placeholder="Type your message..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          disabled={isLoading} // Disable input when isLoading is true
        />
        <button
          type="submit"
          className={`w-12 h-12 rounded-full flex items-center justify-center shadow-lg ${
            isLoading ? 'bg-gray-600 cursor-not-allowed' : 'bg-primaryColor hover:bg-primaryColorDark'
          }`}
          disabled={isLoading} // Disable button when isLoading is true
        >
          <IoSend size={20} color={isLoading ? 'gray' : 'white'} />
        </button>
      </form>
    </div>
  );
};

export default InputBox;